import { NgxsConfig } from '@ngxs/store';
import { ContactRequestState } from '../../page/contact-requests/state/contact-request.state';
import { MeetingState } from '../../page/meetings/state/meeting-state';
import { MilestonesState } from '../../page/milestones/state/milestones.state';
import { QuestionnairesState } from '../../page/questionnaires/state/questionnaires-state';
import { SheroSquadState } from '../../page/shero-squad/state/shero-squad.state';
import { UsersState } from '../../page/users/store/users-state';
import { ApplicationConfig } from './application.config';
import { AuthState } from '../../shared/store/auth/auth.state';
import { ApplicationState } from '../../shared/store/application/application.state';
import { CacheDataState } from '../../shared/store/cache-data/cache-data.state';
import { NgxsStoragePluginOptions } from '@ngxs/storage-plugin';

export const ngxsConfig: Partial<NgxsConfig> = {
  developmentMode: !ApplicationConfig.production,
  selectorOptions: {
    suppressErrors: false,
  },
  compatibility: {
    strictContentSecurityPolicy: true,
  },
};

export const ngxsStorageConfig: NgxsStoragePluginOptions = {
  namespace: ApplicationConfig.applicationName,
  keys: ['auth.token', 'auth.account'],
};

export const ngxsStates = [
  AuthState,
  ApplicationState,
  CacheDataState,
  SheroSquadState,
  ContactRequestState,
  UsersState,
  QuestionnairesState,
  MeetingState,
  MilestonesState
];
